import {
    RESET_START,
    RESET_SUCCESS,
    RESET_FAILURE
} from "./actions";

const initialState = {
    resetting: false,
    resetErrors: null,
    success: false
};

export default (state = {}, action) => {
    const newState = Object.assign({}, initialState, state);

    switch (action.type) {
        case RESET_START:
            newState.resetting = true;
            newState.success = false;
            newState.resetErrors = null;
        break;
        case RESET_SUCCESS:
            newState.resetting = false;
            newState.success = true;
            newState.resetErrors = null;
        break;
        case RESET_FAILURE:
            newState.resetting = false;
            newState.success = false;
            newState.resetErrors = action.payload;
        break;
        default:
        break;
    }

    return newState;
}


// WEBPACK FOOTER //
// ./src/components/app/reset-password/reducer.js